const initScrollTop = (scrollTopBtn) => {
  const offset = 300;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (scrollTopBtn) {
    scrollTopBtn.addEventListener('click', scrollToTop);
  }

  window.addEventListener('scroll', () => {
    const scrollPos = window.scrollY || document.documentElement.scrollTop;
    scrollPos > offset
      ? scrollTopBtn.classList.add('is-active')
      : scrollTopBtn.classList.remove('is-active');
  });
};

export { initScrollTop };
